// This file does not follow import/first and import/order
// As the import order and execution order is important.
import xdkConfigStore from '@accedo/xdk-config'
import domReady from '@accedo/xdk-domready'

import config from './config/xdk.config'

xdkConfigStore.load(config)

import xdk from '@accedo/xdk-core'

const THROTTLE = 300
let lastKeyPress = Date.now()

const onSystemKeydown = ({ id }) => {
  const now = Date.now()

  if (now - lastKeyPress < THROTTLE) {
    console.debug('THROTTLE in action')
    return
  }
  lastKeyPress = now
  console.debug('onSystemKeydown', id)
}

document.addEventListener('VIZIO_LIBRARY_DID_LOAD', () => {
  window.vizioLibLoaded = true
  console.log('vizio library loaded in preflight')
})

domReady(async () => {
  await xdk.load()

  const platform = await xdk.system.getDeviceType()
  const { environment } = xdk

  console.info(`XDK device onload, platform: ${platform}`)

  environment.addEventListener(environment.SYSTEM.KEYDOWN, onSystemKeydown)
})
